import React, {Component} from 'react'
import { css } from 'emotion'
import { default_theme as theme } from '../theme/default'

const style = css`
padding: ${theme.spacing.three};
`

class SidebarContainer extends Component {
    render() {
        const { children } = this.props
        return (
            <div className={style}>
              {children}
            </div>
        )
    }
}
export default SidebarContainer



// WEBPACK FOOTER //
// ./src/components/SidebarContainer.js